import React, { useState } from 'react';
import './index.css';

const StarRating = ({ ratings }) =>
{
    const getRatingString = (num) =>
    {
        const decimalPart = num.toString().split('.')[1];
        const decimalValue = decimalPart ? parseFloat(`0.${decimalPart}`) * 10 : 0;
        const formattedDecimal = decimalValue.toString().padStart(2, '0');
        console.log(`rating-${formattedDecimal}`);
        return `rating-${formattedDecimal}`;
    };


    const renderStars = () =>
    {
        const stars = [];
        for (let i = 1; i <= 5; i++)
        {
            if (i <= ratings)
            {
                stars.push(<div key={i} className="star filled" ></div>);
            } else if (i === Math.ceil(ratings))
            {
                stars.push(<div key={i} className={`star half-filled ${getRatingString(ratings)}`}></div>);
            } else
            {
                stars.push(<div key={i} className="star" ></div>);
            }
        }
        return stars;
    };

    return (
        <div className="star-rating">
            {renderStars()}
        </div>
    );
};

export default StarRating;